const Inboundlist = r => require.ensure([], () => r(require('../../views/Inboundlist/Inboundlist.vue')), 'Inboundlist')
const dealerachievementrate = r => require.ensure([], () => r(require(
	'../../views/home/dealerachievementrate/dealerachievementrate.vue')), 'dealerachievementrate')
const U8invoicelist = r => require.ensure([], () => r(require('../../views/home/U8invoicelist/U8invoicelist.vue')),
	'U8invoicelist')
const U8salesorderreport = r => require.ensure([], () => r(require(
	'../../views/home/U8salesorderreport/U8salesorderreport.vue')), 'U8salesorderreport')
const U8NTSSchedult = r => require.ensure([], () => r(require(
	'../../views/home/U8NTSSchedult/U8NTSSchedult.vue')), 'U8NTSSchedult')
const ProductSalesPromotionAnalyse = r => require.ensure([], () => r(require(
	'../../views/home/ProductSalesPromotionAnalyse/ProductSalesPromotionAnalyse.vue')), 'ProductSalesPromotionAnalyse')
const distributorpurchaseinboundreport = r => require.ensure([], () => r(require(
		'../../views/home/distributorpurchaseinboundreport/distributorpurchaseinboundreport.vue')),
	'distributorpurchaseinboundreport')
const distributorsalesreport = r => require.ensure([], () => r(require(
	'../../views/home/distributorsalesreport/distributorsalesreport.vue')), 'distributorsalesreport')
const uniquecodeinventorylist = r => require.ensure([], () => r(require(
	'../../views/home/uniquecodeinventorylist/uniquecodeinventorylist.vue')), 'uniquecodeinventorylist')
const inventorylist = r => require.ensure([], () => r(require('../../views/home/inventorylist/inventorylist.vue')),
	'inventorylist')
// const reportClockIn = r => require.ensure([], () => r(require(
// 		'../../views/home/reportClockIn/reportClockIn.vue')),
// 	'reportClockIn')
const authorityHospital = r => require.ensure([], () => r(require(
		'../../views/home/authorityHospital/authorityHospital.vue')),
	'authorityHospital')
const orgStockDayByInvAddCode = r => require.ensure([], () => r(require(
		'../../views/home/orgStockDayByInvAddCode/orgStockDayByInvAddCode.vue')),
	'orgStockDayByInvAddCode')
const U8quantityonhandreport = r => require.ensure([], () => r(require(
	'../../views/home/U8quantityonhandreport/U8quantityonhandreport.vue')), 'U8quantityonhandreport')
const RDAUNS = r => require.ensure([], () => r(require('../../views/home/RDAUNS/RDAUNS.vue')), 'RDAUNS')
const invoicelist = r => require.ensure([], () => r(require('../../views/home/invoicelist/invoicelist.vue')),
	'invoicelist')
const U8DeliveryOrderReport = r => require.ensure([], () => r(require(
	'../../views/home/U8DeliveryOrderReport/U8DeliveryOrderReport.vue')), 'U8DeliveryOrderReport')
const deliveryorderlist = r => require.ensure([], () => r(require(
	'../../views/home/deliveryorderlist/deliveryorderlist.vue')), 'deliveryorderlist')
const HospitalProcess = r => require.ensure([], () => r(require(
	'../../views/home/hospitalProcess/hospitalProcess.vue')), 'HospitalProcess')
const despatchUnBillReport = r => require.ensure([], () => r(require(
	'../../views/home/despatchUnBillReport/despatchUnBillReport.vue')), 'despatchUnBillReport')
const ReportIMSSales = r => require.ensure([], () => r(require('../../views/home/reportIMSSales/reportIMSSales.vue')),
	'ReportIMSSales')
const ReportBackupReport = r => require.ensure([], () => r(require(
	'../../views/home/reportBackupReport/reportBackupReport.vue')), 'ReportBackupReport')
const ReportBusinessView = r => require.ensure([], () => r(require(
	'../../views/home/reportBusinessView/reportBusinessView.vue')), 'ReportBusinessView')
const ReportIMSNTSRatio = r => require.ensure([], () => r(require(
	'../../views/home/reportIMSNTSRatio/reportIMSNTSRatio.vue')), 'ReportIMSNTSRatio')
const ReportIMSNTSRatioReport = r => require.ensure([], () => r(require(
	'../../views/home/reportIMSNTSRatioReport/reportIMSNTSRatioReport.vue')), 'ReportIMSNTSRatioReport')
const ReportOrgConsignment = r => require.ensure([], () => r(require(
	'../../views/home/reportOrgConsignment/reportOrgConsignment.vue')), 'ReportOrgConsignment')
const emptySales = r => require.ensure([], () => r(require(
	'../../views/home/emptySales/emptySales.vue')), 'emptySales')
const dispatchList = r => require.ensure([], () => r(require(
	'../../views/home/dispatchList/dispatchList.vue')), 'DispatchList')

const OrgStockMoneyChange = r => require.ensure([], () => r(require(
	'../../views/home/OrgStockMoneyChange/OrgStockMoneyChange.vue')), 'OrgStockMoneyChange')

const ActivityHospitalSalesByTendency = r => require.ensure([], () => r(require(
	'../../views/home/ActivityHospitalSalesByTendency/ActivityHospitalSalesByTendency.vue')), 'ActivityHospitalSalesByTendency')

const U9SRReport = r => require.ensure([], () => r(require(
	'../../views/home/U9SRReport/U9SRReport.vue')), 'U9SRReport')

const PurchaseAveragePrice = r => require.ensure([], () => r(require(
	'../../views/home/PurchaseAveragePrice/PurchaseAveragePrice.vue')), 'PurchaseAveragePrice')

const HomeChildrenRouter = [{
		path: '/Report/ASN',
		name: 'Inboundlist',
		component: Inboundlist,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/CustomerQuota',
		name: 'dealerachievementrate',
		component: dealerachievementrate,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/U8DLReport',
		name: 'U8invoicelist',
		component: U8invoicelist,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/U9SRReport',
		name: 'U9SRReport',
		component: U9SRReport,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/U8SOReport',
		name: 'U8salesorderreport',
		component: U8salesorderreport,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/U8NTSSchedult',
		name: 'U8NTSSchedult',
		component: U8NTSSchedult,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/ProductSalesPromotionAnalyse',
		name: 'ProductSalesPromotionAnalyse',
		component: ProductSalesPromotionAnalyse,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/ASNReport',
		name: 'distributorpurchaseinboundreport',
		component: distributorpurchaseinboundreport,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/DespatchReport',
		name: 'distributorsalesreport',
		component: distributorsalesreport,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/StockUniqueReport',
		name: 'uniquecodeinventorylist',
		component: uniquecodeinventorylist,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/StockReport',
		name: 'inventorylist',
		component: inventorylist,
		meta: {
			typePage: 2
		}
	},
	// ,
	// {
	// 	path: '/Report/ClockIn',
	// 	name: 'reportClockIn',
	// 	component: reportClockIn,
	// 	meta: {
	// 		typePage: 2
	// 	}
	// },
	{
		path: '/Report/AuthorityHospital',
		name: 'authorityHospital',
		component: authorityHospital,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/OrgStockDayByInvAddCode',
		name: 'orgStockDayByInvAddCode',
		component: orgStockDayByInvAddCode,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/U8CSReport',
		name: 'U8quantityonhandreport',
		component: U8quantityonhandreport,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/TransceiversSummary',
		name: 'RDAUNS',
		component: RDAUNS,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/SaleBill',
		name: 'invoicelist',
		component: invoicelist,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/Despatch',
		name: 'deliveryorderlist',
		component: deliveryorderlist,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/U8RDReport',
		name: 'U8DeliveryOrderReport',
		component: U8DeliveryOrderReport,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/HospitalProcess',
		name: 'HospitalProcess',
		component: HospitalProcess,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/despatchUnBillReport',
		name: 'despatchUnBillReport',
		component: despatchUnBillReport,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/IMSSales',
		name: 'ReportIMSSales',
		component: ReportIMSSales,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/BackupReport',
		name: 'ReportBackupReport',
		component: ReportBackupReport,
		meta: {
			typePage: 2
		}
	}, {
		path: '/Report/BusinessView',
		name: 'ReportBusinessView',
		component: ReportBusinessView,
		meta: {
			typePage: 2
		}
	}, {
		path: '/Report/IMSNTSRatio',
		name: 'ReportIMSNTSRatio',
		component: ReportIMSNTSRatio,
		meta: {
			typePage: 2
		}
	}, {
		path: '/Report/IMSNTSRatioReport',
		name: 'ReportIMSNTSRatioReport',
		component: ReportIMSNTSRatioReport,
		meta: {
			typePage: 2
		}
	}, {
		path: '/Report/OrgConsignment',
		name: 'ReportOrgConsignment',
		component: ReportOrgConsignment,
		meta: {
			typePage: 2
		}
	}, {
		path: '/Report/EmptySales',
		name: 'emptySales',
		component: emptySales,
		meta: {
			typePage: 2
		}
	}, {
		path: '/Report/DispatchList',
		name: 'dispatchList',
		component: dispatchList,
		meta: {
			typePage: 2
		}
	}, {
		path: '/Report/OrgStockMoneyChange',
		name: 'ReportOrgStockMoneyChange',
		component: OrgStockMoneyChange,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/ActivityHospitalSalesByTendency',
		name: 'ActivityHospitalSalesByTendency',
		component: ActivityHospitalSalesByTendency,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/Report/PurchaseAveragePrice',
		name: 'PurchaseAveragePrice',
		component: PurchaseAveragePrice,
		meta: {
			typePage: 2
		}
	}
];
export default HomeChildrenRouter